import PropTypes from 'prop-types';
import { Search, X } from 'lucide-react';

import { Button } from '#/modules/commonComponents/button';
import { Input } from '#/modules/commonComponents/form/Input';

/**
 * 工單轉倉「指定工單」欄位：外觀同 floating input，點擊開選工單 dialog，可清除。
 */
const WorkOrderTransferWorkOrderField = ({
  id,
  workOrder = null,
  onOpen,
  onClear,
}) => {
  const valueLabel = workOrder?.workOrderNo || workOrder?.id || '';

  function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onOpen();
    }
  }

  return (
    <div className="input_container mb-0!">
      <div className="relative">
        <Input
          id={id}
          type="text"
          readOnly
          value={valueLabel}
          placeholder="點擊選擇工單"
          onClick={onOpen}
          onKeyDown={handleKeyDown}
          aria-haspopup="dialog"
          className="cursor-pointer! bg-panel! pr-18! tabular-nums"
        />
        <label htmlFor={id} className="input_label">工單</label>
        <div className="absolute inset-y-0 right-1.5 flex items-center gap-0.5">
          {valueLabel ? (
            <Button
              type="button"
              variant="ghost"
              size="icon-sm"
              aria-label="清除工單"
              onClick={onClear}
            >
              <X size={16} aria-hidden />
            </Button>
          ) : null}
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            aria-label="選擇工單"
            onClick={onOpen}
          >
            <Search size={16} aria-hidden />
          </Button>
        </div>
      </div>
    </div>
  );
};

WorkOrderTransferWorkOrderField.propTypes = {
  id: PropTypes.string.isRequired,
  workOrder: PropTypes.shape({
    id: PropTypes.string,
    workOrderNo: PropTypes.string,
  }),
  onOpen: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default WorkOrderTransferWorkOrderField;
